export default "__VITE_ASSET__D8fLc8bz__"